export default __webpack_public_path__ + "static/ikke-endre-logoene-9c66e012f65d938f391e99d88c50c682.png";